// Modelo Provider para administrador.
export default class Provider {
    id=""
    code=""
    name=""
    description=""
}



// WEBPACK FOOTER //
// ./src/model/Provider.js